import React from 'react';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type Props = {
  /** カードタイトル */
  title: string;
  /** 補足説明（1行） */
  description?: string;
  /** 遷移先パス */
  path: string;
  /** アイコン（ReactElement） */
  icon?: React.ReactNode;
  /** アクセントカラー（デフォルト: #1565c0） */
  color?: string;
};

/**
 * 他の記事への内部リンクカード（正方形に近いカード型・別タブで開く）
 */
const WorkflowLinkCard: React.FC<Props> = ({
  title,
  description,
  path,
  icon,
  color = '#1565c0',
}) => {
  return (
    <ButtonBase
      component="a"
      href={path}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        display: 'block',
        width: 360,
        textAlign: 'left',
        border: 1,
        borderColor: 'divider',
        borderRadius: 2,
        overflow: 'hidden',
        transition: 'border-color 0.2s',
        '&:hover': { borderColor: color },
      }}
    >
      {/* 上部カラーバー */}
      <Box sx={{ height: 4, bgcolor: color }} />

      {/* コンテンツ */}
      <Stack spacing={1.5} sx={{ p: 2, minHeight: 100, justifyContent: 'space-between' }}>
        <Stack spacing={1}>
          {icon && (
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: 1.5,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: `${color}14`,
                color: color,
              }}
            >
              {icon}
            </Box>
          )}
          <Typography variant="body2" fontWeight={600} sx={{ lineHeight: 1.4 }}>
            {title}
          </Typography>
          {description && (
            <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.4 }}>
              {description}
            </Typography>
          )}
        </Stack>
        <Stack direction="row" alignItems="center" spacing={0.5} sx={{ alignSelf: 'flex-end' }}>
          <Typography variant="caption" color="text.disabled">
            別タブで開く
          </Typography>
          <OpenInNewIcon sx={{ fontSize: 14, color: 'text.disabled' }} />
        </Stack>
      </Stack>
    </ButtonBase>
  );
};

export default WorkflowLinkCard;
